/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting media import..." |
*
* @param {Media_Import_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_status_starting = /** @type {((inputs?: Media_Import_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de l'importation des medias...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienimport wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio importazione media...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало импорта медиафайлов...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando importación de medios...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导入媒体文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのインポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया आयात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a importação de mídia...")
	return /** @type {LocalizedString} */ ("Starting media import...")
});